import moment from 'moment'
import Axios from 'config/service.config'
import config from 'config/env_config'

export const insertScheduling = async (schedulings, havePayment = false) => {
  const { data } = await Axios({
    baseURL: config.scheduling,
    url: `/schedulings/${havePayment ? '?pay=true' : ''}`,
    data: schedulings,
    method: 'post',
    withCredentials: true
  })

  if (havePayment) {
    window.localStorage.setItem('reservePay', JSON.stringify({
      id: data.id,
      expiresAt: moment().add(process.env.SCHEDULING_TTL, 'minutes').format('YYYY-MM-DD HH:mm')
    }))
  }

  return data
}

export const cancelScheduling = async (id) => {
  const { data } = await Axios({
    baseURL: config.scheduling,
    url: `/schedulings/cancel/${id}`,
    method: 'post',
    withCredentials: true
  })
  return data
}

export const insertReserve = async (schedulings, havePayment = false) => {
  const { data: reserve } = await Axios({
    baseURL: config.scheduling,
    url: `/schedulings/reserve/${havePayment ? '?pay=true' : ''}`,
    data: schedulings,
    method: 'post'
  })
  window.sessionStorage.setItem('reserve', JSON.stringify({
    id: reserve.id,
    expiresAt: moment().add(process.env.SCHEDULING_TTL, 'minutes').format('YYYY-MM-DD HH:mm')
  }))

  if (havePayment) {
    window.sessionStorage.setItem('reserve', JSON.stringify({
      id: reserve.id,
      expiresAt: moment().add(process.env.SCHEDULING_TTL, 'minutes').format('YYYY-MM-DD HH:mm')
    }))
  }
  return reserve
}

export const reschedule = async (id, schedulingData) => {
  const { data } = await Axios({
    baseURL: config.scheduling,
    url: `schedulings/reschedule/${id}`,
    data: schedulingData,
    method: 'post',
    withCredentials: true
  })
  window.localStorage.setItem('reservePay', JSON.stringify({
    id: data.id,
    expiresAt: moment().add(process.env.SCHEDULING_TTL, 'minutes').format('YYYY-MM-DD HH:mm')
  }))
  return data
}

export const getReservePay = () => {
  let reserve = typeof window !== 'undefined' ? JSON.parse(window.localStorage.getItem('reservePay')) : undefined

  // Verifica se a reserva existente já expirou
  if (reserve && moment().isSameOrAfter(reserve.expiresAt)) {
    window.localStorage.removeItem('reservePay')
    reserve = undefined
  }
  return reserve
}

export const getReserve = () => {
  let reserve = typeof window !== 'undefined' ? JSON.parse(window.sessionStorage.getItem('reserve')) : undefined

  // Verifica se a reserva existente já expirou
  if (reserve && moment().isSameOrAfter(reserve.expiresAt)) {
    window.sessionStorage.removeItem('reserve')
    reserve = undefined
  }
  return reserve
}

export const confirmReserve = async (pets) => {
  const { id } = getReserve()

  const { data } = await Axios({
    baseURL: config.scheduling,
    url: `/schedulings/reserve/confirm/${id}`,
    method: 'post',
    withCredentials: true,
    data: pets
  })

  window.sessionStorage.removeItem('reserve')
  return data
}

export const getAllScheduling = async (id, month, currentDate) => {
  try {
    const { data } = await Axios({ baseURL: config.scheduling, url: '/scheduling/user/'.concat(id).concat('?month=').concat(month).concat('&scheduling_date=').concat(currentDate) })
    return data
  } catch (error) {
    return error.response
  }
}

export const getSchedulingById = async (id, multi) => {
  try {
    const { data } = await Axios({
      baseURL: config.scheduling,
      url: `/schedulings/${id}`,
      withCredentials: true,
      params: { multi: multi }
    })
    return data
  } catch (error) {
    return error.response
  }
}

export const getUserSchedulings = async ({ skip, limit, status, payStatus, category, purchasedPackage, includeOverbooks, concatResults }) => {
  try {
    const { data } = await Axios.get(`${config.scheduling}/v2/schedulings`, {
      params: {
        skip,
        limit,
        status,
        payStatus,
        category,
        purchasedPackage,
        includeOverbooks,
        concatResults
      },
      withCredentials: true
    })
    return data
  } catch (error) {
    return error.response
  }
}
export const getAllUserSchedulings = async ({ status, payStatus }) => {
  try {
    const { data } = await Axios.get(`${config.scheduling}/schedulings/schedules/all`, {
      params: {
        status,
        payStatus
      },
      withCredentials: true
    })
    return data
  } catch (error) {
    return error.response
  }
}

const fetchAvailability = async ({ partner, service, breed, temperament, month, year, paidAt, havePayment, additionalServices }) => {
  return (await Axios.get(`${config.scheduling}/schedulings/availability`, {
    params: {
      partner,
      service,
      breed,
      temperament,
      month,
      year,
      paidAt,
      havePayment,
      additionalServices
    },
    withCredentials: true
  })).data
}

/**
 * Calcula as indisponibilidades de horário de profissionais, dadas uma raça de pet, um parceiro,
 * um serviço, um mês e ano.
 */
export const calculateAvailabilities = async ({ partnerId, serviceId, breedId, temperament, month, year, paidAt, havePayment, additionalServices }) => {
  const availability = await fetchAvailability({
    partner: partnerId,
    service: serviceId,
    breed: breedId,
    temperament,
    month,
    year,
    paidAt,
    havePayment,
    additionalServices
  })

  const professionalIds = Object.keys(availability)
  if (!professionalIds.length) {
    return
  }

  return availability
}

export const getSatisfactionSurvey = async (params) => {
  try {
    const { data } = await Axios({
      baseURL: config.partner,
      url: '/satisfaction-survey/find',
      withCredentials: true,
      params
    })
    return data
  } catch (error) {
    return error.response
  }
}

export const getCheckRated = async () => {
  try {
    const { data } = await Axios({
      baseURL: config.scheduling,
      url: '/schedulings/check-rated',
      withCredentials: true
    })
    return data
  } catch (error) {
    return error.response
  }
}

export const setDeclineRating = async (schedulingId) => {
  try {
    const { data } = Axios({
      baseURL: config.scheduling,
      url: `/schedulings/${schedulingId}/decline-rating`,
      withCredentials: true,
      method: 'post'
    })
    return data
  } catch (error) {
    return error.response
  }
}

export const pay = async (schedulings) => {
  try {
    const { data } = await Axios({
      baseURL: config.scheduling,
      url: '/schedulings/payments',
      data: schedulings,
      method: 'post',
      withCredentials: true
    })
    return { success: true, data }
  } catch (error) {
    return { success: false, error: error.response }
  }
}

export const purchaseAndPayPackage = async (servicePackage) => {
  try {
    const { data } = await Axios({
      baseURL: config.scheduling,
      url: '/purchased-packages',
      data: servicePackage,
      method: 'post',
      withCredentials: true
    })
    return { success: true, data }
  } catch (error) {
    return { success: false, error: error.response }
  }
}

export const changePaymentMethod = async (id) => {
  try {
    const { data } = await Axios({
      baseURL: config.scheduling,
      url: `/schedulings/payment/method/${id}`,
      method: 'put',
      withCredentials: true
    })
    return data
  } catch (error) {
    return error.response
  }
}
